import { Auth } from "aws-amplify";
import { AES, enc } from "crypto-js";
import { HttpMainApi } from "../interface/main-api";
import { appConfig } from "../config/Config";

const mainApi = new HttpMainApi();

export async function checkAuthenticated() {
  let result = false;
  await Auth.currentSession()
    .then(async (data) => {
      await Auth.currentAuthenticatedUser()
        .then((data) => {
          result = true;
        })
        .catch((err) => {
          result = false;
        });
    })
    .catch((err) => {
      result = false;
    });
  return result;
}

export async function getUserAttr() {
  try {
    if (!(await checkAuthenticated())) throw Error("user not loged in");
    const user = await Auth.currentAuthenticatedUser();
    const { attributes } = user;
    let rtn_pay_load = {
      email: attributes.email,
      name: attributes.name,
      company: attributes["custom:company"],
    };
    return rtn_pay_load;
  } catch (e) {
    return {
      email: "",
      name: "",
      company: "",
    };
  }
}

export async function checkAdmin() {
  let admin_info: any = {
    isAuth: false,
    isAdmin: false,
    isSuperAdmin: false,
  };
  if (!(await checkAuthenticated())) return admin_info;
  const user = await Auth.currentAuthenticatedUser();
  const param: any = {
    command: "get_user_info",
    user_id: user.attributes.email,
  };
  const res = await mainApi.post(param);
  if (res.code === "200") {
    admin_info.isAuth = res.response.user_info.is_auth;
    admin_info.isAdmin = res.response.user_info.is_admin;
    admin_info.isSuperAdmin = res.response.user_info.is_super_admin;
    admin_info.dtype = res.response.user_info.dtype;
  }
  return admin_info;
}

export async function setChatName(newChatName: string) {
  let loginUser = await Auth.currentAuthenticatedUser();
  let result = await Auth.updateUserAttributes(loginUser, {
    "custom:chat_name": newChatName,
  });
  return result;
}

export async function getChatName() {
  let loginUser = await Auth.currentAuthenticatedUser();
  const { attributes } = loginUser;
  if (attributes["custom:chat_name"] === undefined || attributes["custom:chat_name"] === "") {
    return "";
  } else {
    return attributes["custom:chat_name"];
  }
}

export async function signOut() {
  try {
    await Auth.signOut();
    return true;
  } catch (error) {
    console.error("error signing out: ", error);
    return false;
  }
}

export async function setPicture(path: string) {
  let loginUser = await Auth.currentAuthenticatedUser();
  let result = await Auth.updateUserAttributes(loginUser, {
    picture: path,
  });
  return result;
}

export function getSession() {
  // localStorage에서 가져옴
  const encObjString = window.localStorage.getItem(appConfig.sessionName);

  if (!encObjString) return null;
  try {
    // 가져온것을 decrypt
    const bytes = AES.decrypt(encObjString, appConfig.seed);
    const decrypted = bytes.toString(enc.Utf8);
    let obj = JSON.parse(decrypted);
    if (Date.now() > obj.expire) {
      window.localStorage.removeItem(appConfig.sessionName);
      return false;
    } else {
      // 없다면 encrypt 해서 localStorage에 저장
      obj.expire = Date.now() + appConfig.sessionTimeout;
      const objString = JSON.stringify(obj);
      const encObjString = AES.encrypt(objString, appConfig.seed).toString();
      window.localStorage.setItem(appConfig.sessionName, encObjString);
    }
    // decrypt한 obj를 리턴
    return obj;
  } catch (error) {
    window.localStorage.removeItem(appConfig.sessionName);
    return null;
  }
}